import { Component, OnInit, forwardRef } from '@angular/core';
import { UrlHelperService } from '@core/services/url-helper.service';
import { CustomSelect } from '../../ui/select-controls/custom-select.model';
import { AppSettings } from '@core/literals/app-settings.literal';
import { SelectFieldComponent } from '../select-field/select-field.component';

interface UrlSetting {
  url: string,
  name: string
}

@Component({
    selector: 'app-url-setting',
    imports: [forwardRef(() => SelectFieldComponent)],
    templateUrl: './url-setting.component.html',
    styleUrls: ['./url-setting.component.css']
})
export class UrlSettingComponent implements OnInit {

  constructor(private urlHelper: UrlHelperService) { }

  customSelect: CustomSelect;

  ngOnInit(): void {

    var data: Array<UrlSetting> = [
      { url: AppSettings.LocalDevelopmentApiUrl, name: "Local Development (localhost)" },
      { url: AppSettings.DevelopmentApiUrl, name: "Development (api.development.redeployment.app)" },
      { url: AppSettings.ProductionApiUrl, name: "Production (api.epc.redeployment.com)" }
    ];

    var currentUrl: string = this.urlHelper.getApiUrl();
    var selected: UrlSetting | undefined;

    if (currentUrl != undefined && currentUrl.length > 0) {
      selected = data.find(u => u.url == currentUrl);
      if (selected) {
        data.splice(data.indexOf(selected), 1);
        data.unshift(selected);
      } else {
        selected = data.find(n => n.name == 'Development');
        if (selected) {
          data.splice(data.indexOf(selected), 1);
          data.unshift(selected);
        }
      }
    } else {
      selected = data.find(n => n.name == 'Development');
      if (selected) {
        data.splice(data.indexOf(selected), 1);
        data.unshift(selected);
      }
    }

    this.customSelect = new CustomSelect("urlSetSelect", "URL", selected);
    this.customSelect.data = data;
    this.customSelect.displayMember = "name";
    this.customSelect.valueMember = "url";
  }

  onChange(obj: any): void {
    if (obj) {
      this.urlHelper.setUrl(obj.value.url);
    }
  }

}
